import officeAudio from './audioFiles/officeStory.mp3'
import libraryAudio from './audioFiles/libraryStory.mp3'
import laboratoryAudio from './audioFiles/labStory.mp3'
import fourJokersAudio from './audioFiles/fourJokersStory.mp3'
import lastStandAudio from './audioFiles/lastStandStory.mp3'
import machineAudio from './audioFiles/machineStory.mp3'

const audioIndex = {
    office: officeAudio,
    library: libraryAudio,
    laboratory: laboratoryAudio,
    fourJokers: fourJokersAudio,
    lastStand: lastStandAudio,
    machine: machineAudio
}

export default audioIndex